import 'css-chunk:src/app/containers/Home/CommunitiesView/ProgramsDetailView/ProgramInviteTemplate.scss';export default {
  "ProgramInviteTemplate": "_ProgramInviteTemplate_1dk0y_1"
};